<div class="d-flex flex-column main-container">
    <div class="header h3-title">
        {{ document.Name }}
    </div>
    <div class="d-flex flex-column content">
        <div class="d-flex flex-row">
            <div class="bold-text">{{ 'effDocumentDetails.user' | t }}</div>
            <div class="d-flex regular-text">{{ document.Username }}</div>
        </div>
        <div class="d-flex flex-row">
            <div class="bold-text">{{ 'effDocumentDetails.date' | t }}</div>
            <div class="d-flex regular-text">{{ document.Date | dateTimeFormat: true }}</div>
        </div>
        <div class="d-flex flex-row">
            <div class="bold-text">{{ 'effDocumentDetails.versions' | t }}</div>
            <div class="d-flex regular-text">{{ document.Version }}</div>
        </div>
        <div class="d-flex flex-row">
            <div class="bold-text">{{ 'effDocumentDetails.type' | t }}</div>
            <div class="d-flex regular-text">{{ document.DocumentType }}</div>
        </div>
        <div class="d-flex flex-row">
            <div class="bold-text">{{ 'effDocumentDetails.description' | t }}</div>
            <div class="d-flex regular-text">{{ document.Description }}</div>
        </div>
    </div>
</div>
